// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-of-service-notice {
    margin: 50px auto;
    padding: 0;
    max-width: 600px;
}
.terms-of-service-notice__logo {
    text-align: center;
}
.terms-of-service-notice__instructions {
    max-width: 600px;
    text-align: center;
}
.card.terms-of-service-notice__terms-card {
    max-width: 600px;
    padding: 20px;
}
.terms-of-service-notice__close {
    padding: 10px;
    text-align: center;
}

`, "",{"version":3,"sources":["webpack://./client/components/notices/TermsOfServiceNotice/TermsOfServiceNotice.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".terms-of-service-notice {\n    margin: 50px auto;\n    padding: 0;\n    max-width: 600px;\n}\n.terms-of-service-notice__logo {\n    text-align: center;\n}\n.terms-of-service-notice__instructions {\n    max-width: 600px;\n    text-align: center;\n}\n.card.terms-of-service-notice__terms-card {\n    max-width: 600px;\n    padding: 20px;\n}\n.terms-of-service-notice__close {\n    padding: 10px;\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
